import axios from 'axios';
import cfac22 from '../../cfac22';

export const login = async (...args) => {
  const params =
    args.length === 1 && args[0] && typeof args[0] === 'object' && !Array.isArray(args[0])
      ? args[0]
      : Object.fromEntries(
          ['identifier', 'partnerId', 'code', 'clientType', 'fingerprint'].map((key, index) => [
            key,
            args[index],
          ])
        );
  const { identifier, partnerId, code, clientType, fingerprint } = params;

  try {
    const endpoint = `${cfac22('MICROSERVICES')}/auth/login`;

    const { data } = await axios.post(
      endpoint,
      {
        identifier,
        partnerId,
        code,
        clientType,
        fingerprint,
      },
      {
        withCredentials: true,
        headers: {
          'Full-Url': window.location.href,
        },
      }
    );

    const { success, result, error } = data;

    if (!success) {
      return {
        success: false,
        error: error || 'Erro ao realizar login',
      };
    }

    const { accessToken, sessionId, userUId } = result;

    return {
      success: true,
      data: {
        accessToken,
        sessionId,
        userUId,
      },
    };
  } catch (error) {
    console.error('LOGIN API - Error:', error);
    throw error?.response?.data || error;
  }
};
